import React from 'react';
import { RunStatusPill, ModeChip, ProgressBar, money, fmtWhen } from './ui';

const RUNNING = new Set(['queued', 'researching', 'generating', 'rendering', 'publishing']);

/** One row in the RUNS panel. Whole row is tappable; VIEW → is the right-hand affordance. */
export default function RunRow({ run, onOpen, active: open = false }) {
  const active = RUNNING.has(run.status);
  return (
    <div
      className="pe-row border-t border-[#F2F2F2] font-mono cursor-pointer"
      style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10, background: open ? '#F5F5F5' : undefined }}
      aria-current={open ? 'true' : undefined}
      onClick={() => onOpen(run.id)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') onOpen(run.id); }}
    >
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-bold uppercase" style={{ fontSize: 14, letterSpacing: '0.05em' }}>{run.regionName}</span>
        <ModeChip mode={run.mode} />
        <RunStatusPill status={run.status} />
        <button
          type="button"
          className="ml-auto font-bold underline hover:opacity-80"
          style={{ fontSize: 12 }}
          onClick={(e) => { e.stopPropagation(); onOpen(run.id); }}
        >
          VIEW →
        </button>
      </div>
      <div className="flex items-center gap-3">
        <ProgressBar percent={run.progress} height={12} pulse={active} className="flex-1" />
        <span className="uppercase whitespace-nowrap" style={{ fontSize: 11, color: '#6B7280', letterSpacing: '0.05em' }}>{run.stageLabel}</span>
      </div>
      <div className="uppercase" style={{ fontSize: 11, letterSpacing: '0.05em' }}>
        <span className="hidden sm:inline">
          {run.conceptsGenerated} CONCEPTS · {run.conceptsPublished} PUBLISHED · {run.hostsInvited} HOSTS INVITED · {run.conceptsClaimed} CLAIMED
        </span>
        <span className="sm:hidden">{run.conceptsGenerated} CONCEPTS · {run.conceptsPublished} PUBLISHED</span>
        <span style={{ color: '#9CA3AF' }}> · </span>
        <span className="font-bold">{money(Math.round(run.estimatedCostUsd * 100))}</span>
      </div>
      <div className="uppercase" style={{ fontSize: 10, color: '#9CA3AF', letterSpacing: '0.05em' }}>
        STARTED BY @{(run.requestedByHandle || 'admin').toUpperCase()} · {fmtWhen(run.createdAt)}
      </div>
    </div>
  );
}
